import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import CumPerfRow from './CumPerfRow'
import { setActivePane, paneOpts } from '../../../actions'
import './PerformanceTable.css'
import i18n from '../../../i18n'

class CumPerfTable extends Component {
  viewStdPerf() {
    this.props.setActivePane(paneOpts.details)
  }
  // create the rows
  renderRows() {
    const { data, wtRegion } = this.props
    const stdPerformanceDaily = data[0]?.stdPerformanceDaily?.[0]

    if (!stdPerformanceDaily) {
      return null
    }

    return data.map(fund => {
      return <CumPerfRow key={fund.externalID} fund={fund} wtRegion={wtRegion} />
    })
  }

  // create the header
  renderHeader() {
    const { wtRegion, data } = this.props
    const stdPerformanceDaily = data[0]?.stdPerformanceDaily?.[0]

    if (!stdPerformanceDaily) {
      return null
    }

    const asOfDate = new Date(this.props.data[0].stdPerformanceDaily[0].asOfDate).toLocaleDateString()
    const commonStartDate = new Date(this.props.data[0].stdPerformanceDaily[0].commonPeriodNAVStart).toLocaleDateString()
    const commonEndDate = new Date(this.props.data[0].stdPerformanceDaily[0].commonPeriodNAVEnd).toLocaleDateString()
    return (
      <thead>
        <tr>
          <th colSpan='3' className='textLeft'>
            PERFORMANCE {i18n.t('as of')} {asOfDate}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th colSpan='3' className='borderleft borderbottom textCenter'>
                {i18n.t('Cumulative Returns')}
              </th>
            </Fragment>
          )}
          <th colSpan='6' className='borderleft borderbottom textCenter'>
            {i18n.t('Average Annual Total Returns')}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>
            {i18n.t('Ticker')}
          </th>
          <th scope='col' className='textLeft'>
            {i18n.t('Fund')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Inception')}
            <br /> {i18n.t('Date')}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th scope='col' className='borderleft textCenter'>
                {i18n.t('1-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('3-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('YTD')}
              </th>
            </Fragment>
          )}
          <th scope='col' className='borderleft textCenter'>
            {i18n.t('1-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('3-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('5-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('10-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Since')} <br />
            {i18n.t('Inception')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Common Period')}
            <br /> {commonStartDate} - {commonEndDate}{' '}
          </th>
        </tr>
      </thead>
    )
  }

  render() {
    return (
      <div>
        {/* <div className={s.heading} style={{lineHeight:'14px', marginBottom:'13px'}}>{i18n.t('Performance')}</div> */}
        <div className='table-responsive'>
          <table className='table tableFC'>
            {this.renderHeader()}
            <tbody>{this.renderRows()}</tbody>
          </table>
        </div>
        <div style={{ marginTop: '15px' }}>
          <a className='tickerLink' onClick={() => this.viewStdPerf()}>
            View quarterly standardized performance
          </a>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    wtRegion: state.params.wtRegion
  }
}

export default connect(mapStateToProps, {
  setActivePane
})(CumPerfTable)
